module.exports = __webpack_public_path__ + "portal-static/img/bg1.c58d899c.jpg";